import React, { useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import _, { isEqual, isNil } from 'lodash';
import TasksListPopover from '../workflow/TasksListPopover';
import ValidateButtonAction from 'components/ValidateButtonAction';
import RefuseButtonAction from 'components/RefuseButtonAction';
import UploadButtonAction from 'components/UploadButtonAction';
import DocCodeSelect from 'components/ParDocCodeSelect/DocCodeSelect';
import {
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  notification,
  Row,
  Upload,
} from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { shouldUpdateCompare } from 'utils/utils2';
import {
  LikeTwoTone,
  DislikeTwoTone,
  UserSwitchOutlined,
} from '@ant-design/icons';
import {
  DocListSearchResponse,
  findDocumentsByAnyRef,
  updateDocPathByDocid,
  updateDocStatusByDocid,
  addDocument,
  loadFileAsResource,
} from 'services/Document';
import FormInput from 'components/FormInput';
import { ACCESS_TOKEN } from 'utils/config';
import { Document, Page } from 'react-pdf';
import Modal from 'antd/lib/modal/Modal';
import ThirdPartyInput, {
  ThirdPartyForProposalType,
} from 'components/ThirdPartyInput';
import ProposalSelect from 'components/ProposalSelect';
import AssetSelect from 'components/AssetSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import GuarantySelect from 'components/GuarantySelect';
import CollectionSelect from 'components/CollectionSelect';
import ButtonComponent from 'components/Button';

import ButtonAction from 'components/ButtonAction';
import NextButton from 'components/NextButton';
import PrevButton from 'components/PrevButton';
import ModalController from 'components/ModalController';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import GuarantDetailModal from 'pages/guaranty/guarantyDetails/guarantyDetailsModal';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetDetails from 'pages/Asset/AssetDetail';
import ButtonOperation from 'components/ButtonOperation';
import NewButton from 'components/NewButton';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import PaymentSelect from 'components/PaymentSelect';
import { UploadDocumentFile } from 'utils/request';

type Values = {
  document: DocListSearchResponse[];
};
export type docListProps = {
  objectid?: number;
  objecttype?: string;
  objectreference?: string;
  objectname?: string;
  tpid?: number;
  hideCol?: boolean;
  categorie?: string;
  doccode?: string;
  applyFilter?: boolean;
  _hideFilters?: boolean;
  showAsModal?: boolean;
  status?: string;
  fromproposal?: boolean;
  showBtn?: boolean;
  title?: boolean;
  hideBtn?: boolean;
  pagination?: any;
  entityValue?: ThirdPartyForProposalType;
  refetchProp?: any;
  setcompleted?: any;
  completed?: boolean;
  taskid?: number;
  flagattachment?: boolean;
  rowSelection?: any;
  setSelectedDocuments?: any;
  isActive?: boolean;
};
const DocList = ({
  entityValue,
  objectid,
  objecttype,
  objectname,
  tpid,
  hideCol,
  categorie,
  _hideFilters,
  pagination,
  doccode,
  showAsModal,
  applyFilter,
  status,
  fromproposal,
  showBtn,
  title,
  hideBtn,
  refetchProp,
  setcompleted,
  completed,
  taskid,
  flagattachment,
  rowSelection,
  setSelectedDocuments,
  objectreference,
  isActive
}: docListProps) => {
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();

  const checkcategory = categorie ?? 'DOC';
  const fieldName = 'Document';

  const [Params, setParams] = useState<any>({
    doclists: [],
    DOCTYPE: [],
    DOCCODE: [],
    random: 0,
    previewImage: '',
    previewVisibleDOC: false,
    numPages: null,
    pageNumber: 1,
    scale: 1,
    previewTitle: '',
    isPDF: false,
    showAddDocument: false,
    doccode: '',
    loadingUpload: false,
    ok: true,
    goodtype: false,
  });
  let [numPages, setNumPages] = useState(0);

  const [pageNumber, setPageNumber] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [failed, setfailed] = useState(true);

  const [fileList, setFileList] = useState<any[]>([]);

  const hideFilters = objecttype === '' || objecttype === undefined;

  const [info, setinfo] = useState('');
  const [scale, setscale] = useState(1);
  const [doctype, setdoctype] = useState('');

  const handlePreviewDOC = (filename: any) => {
    let ext = filename.substring(filename.lastIndexOf('.') + 1);

    loadFileAsResource({ filename }).then((res: any) => {
      setParams({
        previewVisibleDOC: true,
        previewTitle: filename,
        previewImage: res.description,
        isPDF: ext === 'pdf' ? true : false,
      });
    });
  };

  const handleAddDocument = () => {
    if (objecttype) formModal.setFieldsValue({ docmodule: objecttype });
    setParams({ showAddDocument: true });
  };

  const handleCancelPreviewDOC = () => setParams({ previewVisibleDOC: false });
  function onDocumentLoadSuccess({ numPages }: any) {
    setinfo('');
    setNumPages(numPages);
  }
  const onChangepdfZoom = (value: any) => {
    setscale(value / 100);
  };

  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  const UpdateDocumentPathbyDocID = (record: any, _filename: any) => {
    updateDocPathByDocid({
      docid: record.docid,
      docmodule: record.docmodule,
      docpath: _filename,
      objectid: record.objectid,
    })
      .then((response) => {
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            description: response.message + ' ' + response.description,
            duration: 0,
          });
          refetch();
        } else {
          refetch();
        }
      })
      .catch((err) => { });
  };

  const handleCancelAddDocument = () => setParams({ showAddDocument: false });
  const handleUpdateDocStatus = (
    objectid: number,
    objecttype: any,
    docid: any,
    docstatus: any,
    doublecheck: any
  ) => {
    updateDocStatusByDocid({
      doccheckstatus: doublecheck,
      docid: docid,
      docmodule: objecttype,
      docstatus: docstatus,
      docstatuscomment: docstatus,
      docstatusreason: docstatus,
      objectid: objectid,
      checkcategory: categorie ?? '',
    }).then((response) => {
      if (response.code !== '200') {
        notification.error({
          message: response.message,
          description: response.message + ' ' + response.description,
          duration: 0,
        });
        refetch();
      } else {
        notification.success({
          message: 'good',
          description: response.message + ' ' + response.description,
        });
        refetch();
      }
    });
  };

  const handleUpload = (record: any, info: any, __filename: string) => {
    // if (info.status === 'uploading') {
    //   setParams({ loadingUpload: true });
    //   return;
    // }

    const objtype = objecttype
      ? objecttype
      : formModal.getFieldValue('docmodule');
    const doccode =
      Params.doccode && Params.doccode.length > 0
        ? Params.doccode
        : formModal.getFieldValue('doccode');
    const doctype = formModal.getFieldValue('doctype');

    const obid = objectid ? objectid : formModal.getFieldValue('objectid');

    // if (info.status === 'done') {
    if (record === 0 && Params.goodtype) {
      addDocumentAction(obid, objtype, doctype, doccode, __filename);
      setParams({ showAddDocument: false, loadingUpload: false });
    } else {
      setParams({ loadingUpload: false });
      UpdateDocumentPathbyDocID(record, __filename);
    }
    notification.success({ message: 'upload with success' });
    // } else {
    //   notification.error({ message: 'error upload...' });
    //   refetch();
    //   setParams({ loadingUpload: false });
    // }
  };

  const addDocumentAction = (
    objectid: any,
    objecttype: any,
    doctype: any,
    doccode: any,
    filename: any
  ) => {
    setLoadingBtn(true);
    addDocument({
      doccode: doccode,
      docmodule: objecttype,
      docpath: filename,
      doctype: doctype,
      objectid: objectid,
      checkcategory: checkcategory,
      tpid: tpid ?? 0,
      tpreference: objectreference ?? '',
      tpname: objectname ?? '',
      taskid: taskid ?? 0,
      flagattachment: flagattachment ?? false,
    })
      .then((response) => {
        if (response.code !== '200') {
          setLoadingBtn(false);
          notification.error({
            message: response.message,
            description: response.message + ' ' + response.description,
            duration: 0,
          });
          refetch();
        } else {
          setLoadingBtn(false);
          setParams({ ok: false });
          refetch();
        }
      })
      .catch((err) => {
        setLoadingBtn(false);
      });
  };
  const [Tpid, setTpid] = useState(0);
  const [checkdocmodule, setcheckdocmodule] = useState(objecttype);
  const intValueSearch = {
    doccode: doccode ?? '',
    docmodule: objecttype || '',
    docstatus: '',
    doctype: '',
    objectid: objectid || ('' as any),
    objectreference: '',
    tpid: tpid || ('' as any) || Tpid,
    tpname: '' as any,
    tpreference: '',
    checkcategory: categorie ?? '',
    applyFilter: applyFilter ?? false,
    taskid: 0,
  };

  const [searchParams, setSearchParams] = useState(intValueSearch);

  const [searchs, setsearchs] = useState(isActive ?? false);

  const [selectedObjectid, setSelectedObjectid] = useState(0);
  const [objectName, setobjectName] = useState(objectname);

  let { data, refetch, isFetching } = useQuery(
    ['findDocumentsByAnyRef', searchParams, tpid, refetchProp],
    () =>
      findDocumentsByAnyRef({
        ...searchParams,
        tpid: tpid ? tpid : Tpid ? Tpid : 0,
      }).then((res) => {
        Params.ok = true;
        //filter = res.data
        return res.list || [];
      }),
    {
      enabled: searchs && ((!isNil(objectid) && !isNaN(objectid))) && isActive !== false,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (objecttype) {
      formModal.setFieldsValue({ docmodule: objecttype, objectid: objectid });
    }
    if (data) {
      form.setFieldsValue({ [fieldName]: data });
      setcompleted && setcompleted(true);
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, data, objecttype, formModal, objectid, checkdocmodule]);

  rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      let listDocs = '';
      for (const i in selectedRows) {
        listDocs = selectedRows[i].docid + `,` + listDocs;
        form.setFieldsValue({
          row: Number(i),
        });
      }
      setSelectedDocuments(selectedRows);

      selectedRows.forEach((row: any, index: number) => {
        form.setFieldsValue({
          docid: row.docid,
        });
      });

      // setSuccessful(selectedRowKeys?.length > 0 ? false : true);
    },
  };

  const columns = useMemo<DataGridColDef<DocListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'docmodulelabel',
        filtrable: 'docmodule',
        filterComponent: (
          <ParListSelect
            onClear={() => {
              setdoctype('');
              form.resetFields();
              setcheckdocmodule('');
              setSelectedObjectid(0);
            }}
            allowClear
            parcode="DOCMODULE"
            onSelect={(e) => {
              setdoctype('');
              setcheckdocmodule(e);
              searchParams.doctype = '';
              form.resetFields();
              setobjectName(objectname ?? objectname);
            }}
            disabled={
              !!objecttype &&
              objecttype !== 'THIRDPARTY' &&
              objecttype !== 'ASSET' &&
              objecttype !== 'PROPOSAL'
            }
          // onChange={(e)=>{ , objecttype}}
          />
        ),
        width: '170px',
      },
      {
        dataIndex: 'objectid',
        filtrable: true,
        filterComponent:
          checkdocmodule === 'THIRDPARTY' && objecttype === 'PROPOSAL' ? (
            <ThirdPartyInput
              onlytpid
              display
              valueToDisplay={{
                tpid: entityValue?.tpid,
                tpreference: entityValue?.tpreference,
                tpname: entityValue?.tpname,
              }}
              onChange={(e) => {
                setTpid(e.tpid);
              }}
            />
          ) : objecttype && checkdocmodule === objecttype ? (
            checkdocmodule === 'THIRDPARTY' ? (
              <ThirdPartyInput
                onlytpid
                display
                valueToDisplay={{
                  tpid: objectid,
                  tpreference: objectreference,
                  tpname: objectname,
                }}
                onChange={(e) => {
                  setTpid(e.tpid);
                }}
              />
            ) : checkdocmodule === 'PROPOSAL' ? (
              <ProposalSelect
                phase=""
                isCreate
                onlyctrid
                display
                valueToDisplay={{
                  ctrid: objectid,
                  propreference: objectreference,
                  clientname: objectname,
                }}
                objectName={objectname}
              />
            ) : checkdocmodule === 'ASSET' ? (
              <AssetSelect
                onlyAssetId
                display
                valueToDisplay={{
                  assetid: objectid,
                  assetreference: objectreference,
                  assetlabel: objectname,
                }}
              />
            ) : (
              <Input disabled />
            )
          ) : checkdocmodule === 'THIRDPARTY' ? (
            <ThirdPartyInput
              onlytpid
              onSelected={(e: any) => {
                setSelectedObjectid(e.tpid);
                setTpid(e.tpid);
              }}
            />
          ) : checkdocmodule === 'PROPOSAL' ? (
            <ProposalSelect
              phase=""
              isCreate
              onlyctrid
              onSelected={(e: any) => {
                setSelectedObjectid(e.ctrid);
              }}
              objectName={objectname}
            />
          ) : checkdocmodule === 'ASSET' ? (
            <AssetSelect onlyAssetId />
          ) : checkdocmodule === 'SINVOICE' ? (
            <SupplierInvoiceSelect onlysiid />
          ) : checkdocmodule === 'CINVOICE' ? (
            <ClientInvoiceSelect
              onSelected={(e: any) => {
                setSelectedObjectid(e.ciid);
              }}
              onlyCiid
            />
          ) : checkdocmodule === 'CONTRACT' ? (
            <ProposalSelect
              PropOrProd="PROD"
              phase=""
              onlyctrid
              onSelected={(e: any) => {
                setSelectedObjectid(e.ctrid);
              }}
            />
          ) : checkdocmodule === 'GUARANTY' ? (
            <GuarantySelect
              onChange={(e: any) => {
                setSelectedObjectid(e.guarid);
              }}
            />
          ) : checkdocmodule === 'COLLECTION' ? (
            <CollectionSelect
              onChange={(e: any) => {
                setSelectedObjectid(e.colid);
              }}
              onlyColid
              tpid={tpid}
            />
          ) : checkdocmodule === 'PAYMENT' ? (
            <PaymentSelect
              onlyPayid
              onChange={(e: any) => {
                setSelectedObjectid(e.payid);
              }}
            />
          ) : (
            <Input disabled defaultValue="Please select an object" />
          ),
        width: '150px',
        render: (value, record) => (
          <div>
            <ModalController>
              {({ setVisible, visible }) => (
                <>
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                  {record.docmodule === 'THIRDPARTY' ? (
                    <ThirdPartyModal
                      tpId={record.tpid}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title={record.tpname}
                      iscreate={false}
                    />
                  ) : record.docmodule === 'PROPOSAL' ? (
                    <ProposalModal
                      ctrid={record.objectid}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.docmodule === 'ASSET' ? (
                    <AssetDetails
                      assetid={record.objectid}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      hideSaveBtn
                      phaseprop="PROPOSAL"
                      iscreate={false}
                    />
                  ) : record.docmodule === 'SINVOICE' ? (
                    <SIDetail
                      siid={record.objectid}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      showButtons={false}
                    />
                  ) : record.docmodule === 'CONTRACT' ? (
                    <ProposalModal
                      ctrid={record.objectid}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.docmodule === 'GUARANTIES' ? (
                    <GuarantDetailModal
                      guarId={String(record.objectid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title={record.tpreference + '-' + record.tpname}
                      iscreate={false}
                    />
                  ) : record.docmodule === 'COLLECTION' ? (
                    <CIDetail
                      ciid={Number(record.objectid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                    />
                  ) : (
                    ''
                  )}
                </>
              )}
            </ModalController>
          </div>
        ),
      },
      {
        dataIndex: 'doctype',
        filtrable: true,
        filterComponent: checkdocmodule ? (
          <ParListSelect
            parvalueparent={checkdocmodule}
            allowClear
            parcode="DOCTYPE"
          />
        ) : (
          <ParListSelect
            parvalueparent={objecttype}
            allowClear
            parcode="DOCTYPE"
          />
        ),
        render: (val, record) => record.doctypelabel,
        width: '120px',
      },
      // {
      //   dataIndex: 'doccode',
      //   filtrable: true,
      //   filterComponent: (
      //     <DocCodeSelect doctype={doctype} docmodule={checkdocmodule} onChange={(e: any) => {
      //
      //       searchParams = ({ ...searchParams, doccode: e });
      //     }}
      //       allowClear
      //     />

      //   ),
      //   render: (val, record) => record.doccode,
      //   width: '100px',
      // },
      {
        dataIndex: 'doclabel',
        width: '250px',
        filtrable: 'doccode',
        filterComponent: (
          <DocCodeSelect
            doctype={doctype}
            docmodule={objecttype ? objecttype : checkdocmodule}
            onChange={(e: any) => {
              setSearchParams({ ...searchParams, doccode: e });
            }}
            allowClear
          />
        ),
        render: (text, record) =>
          record.docpath != null ? (
            <div>
              {record.doclabel}
              <br></br>
              <a
                onClick={(e) => {
                  e.stopPropagation();
                  // handlePreviewDOC(record.docpath);
                  handlePreviewDOC(record.docpath);
                }}
              >
                {record.docpath.substring(record.docpath.lastIndexOf('/') + 1)}
              </a>
            </div>
          ) : (
            record.doclabel
          ),
      },

      {
        dataIndex: 'tpname',
        comcode: 'Document.tpname',
        width: '200px',
        render: (value, record) => (
          <ModalController>
            {({ setVisible, visible }) => (
              <>
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
                <ThirdPartyModal
                  tpId={record.tpid}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.tpname}
                  iscreate={false}
                />
              </>
            )}
          </ModalController>
        ),
      },

      {
        dataIndex: 'requesttypelabel',
        comcode: 'Document.requesttypelabel',
        width: '120px',
        align: 'left',
      },

      {
        dataIndex: 'docdoublecheck',
        comcode: 'Document.docdoublecheck',
        width: '130px',
        align: 'right',
        render: (text, record) => (
          <Checkbox checked={record.docdoublecheck}></Checkbox>
        ),
      },
      {
        dataIndex: 'doccheckstatus',
        comcode: 'Document.doccheckstatus',
        width: '80px',
        align: 'center',
        render: (text, record) =>
          (record.doccheckstatus === 'VALID' && <LikeTwoTone />) ||
          (record.doccheckstatus === 'REFUSE' && <DislikeTwoTone />) ||
          (record.doccheckstatus === 'DDCHECK' && <UserSwitchOutlined />),
      },
      {
        dataIndex: 'doccheckusername',
        comcode: 'Document.doccheckusername',
        width: '150px',
        align: 'center',
      },
      {
        dataIndex: 'docstatus',
        filtrable: true,
        filterComponent: <ParListSelect parcode="DOCSTATUS" allowClear />,
        comcode: 'Document.docstatuslabel',
        width: '120px',
        align: 'center',
        fixed: 'right',
        render: (text, record) => (
          // record.doccheckstatus === 'VALID' ? (
          //   <div style={{ color: 'green' }}>{record.docstatuslabel}</div>
          // ) : record.doccheckstatus === 'REFUSE' ? (
          //   <div style={{ color: 'red' }}>{record.docstatuslabel}</div>
          // ) : record.doccheckstatus === 'TOLOAD' ? (
          //   <div style={{ color: 'black' }}>{record.docstatuslabel}</div>
          // ) :
          //   <div style={{ color: 'blue' }}>{record.docstatuslabel}</div>

          <div
            style={{
              color:
                record.docstatus === 'VALID'
                  ? '#00B52C'
                  : record.docstatus === 'REFUSE'
                    ? 'red'
                    : record.docstatus === 'TOLOAD'
                      ? 'balck'
                      : 'blue',
            }}
          >
            {record.docstatuslabel}
          </div>
        ),
      },
      {
        key: 'operation',
        render: (text, record) => (
          <Row>
            <Col span={24}>
              {record.docstatus === 'TOCHECK' &&
                record.docdoublecheck === false && (
                  <>
                    <ValidateButtonAction
                      onlyIcon
                      style={{ width: '50%' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpdateDocStatus(
                          record.objectid,
                          record.docmodule,
                          record.docid,
                          'VALID',
                          record.docdoublecheck
                        );
                      }}
                    />
                    <RefuseButtonAction
                      onlyIcon
                      style={{ width: '50%' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpdateDocStatus(
                          record.objectid,
                          record.docmodule,
                          record.docid,
                          'REFUSE',
                          record.docdoublecheck
                        );
                      }}
                    />
                  </>
                )}
            </Col>
            <Col span={24}>
              {record.docstatus === 'VALID' && record.docdoublecheck === false && (
                <RefuseButtonAction
                  onlyIcon
                  style={{ width: '50%' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUpdateDocStatus(
                      record.objectid,
                      record.docmodule,
                      record.docid,
                      'REFUSE',
                      record.docdoublecheck
                    );
                  }}
                  icon={<DislikeTwoTone twoToneColor="red" />}
                />
              )}
            </Col>
            <Col span={24}>
              {record.docdoublecheck === true && record.docstatus !== 'TOLOAD' && (
                <TasksListPopover
                  entityId={record.docid}
                  entityReference={'CODE : ' + record?.doccode}
                  entityName="DOCUMENT"
                  title={record?.doclabel + ' - ' + record?.tpname}
                  onClose={refetch}
                >
                  <ButtonAction onlyIcon style={{ width: 80 }} />
                </TasksListPopover>
              )}
            </Col>
            <Col span={24}>
              {(record.docstatus === 'TOLOAD' ||
                record.docstatus === 'REFUSE') && (
                  <Upload
                    style={{ width: 80 }}
                    name="avatar"
                    multiple={false}
                    customRequest={async (options: any) => {
                      await UploadDocumentFile(
                        options.file,
                        record.objectreference ?? ''
                      ).then((res: any) => {
                        console.log('res__________', res);
                        if (res.code === '200') {
                          options.onSuccess();
                          handleUpload(record, options.file, res.description);
                        } else {
                          console.log('res error::', res);
                          options.onError();
                          notification.error({
                            // description: res.message,
                            message: res.message.startsWith('Maximum upload size')
                              ? 'La taille du fichier dépasse la taille autorisée.'
                              : res.message.startsWith('Please select a file to upload with acceptable type')
                                ? "Le format du fichier n'est pas supporté."
                                : res.message,
                          });
                        }
                      });
                    }}
                    // headers={{
                    //   method: 'POST',
                    //   // body: formData,
                    //   Authorization: `Bearer ${accessToken}`,
                    //   mode: 'cors',
                    //   host: 'https://scania.utina.io:9100',
                    //   'Dev-Stage': 'true',
                    //   ACCESS_TOKEN:`Bearer ${accessToken}`,
                    // }}
                    method="POST"
                    onPreview={Params.handlePreviewDOC}
                    beforeUpload={(file) => {
                      setParams({ ...Params, goodtype: true });

                      let parts = file.name.split('.');

                      console.log('parts', parts);
                      let _objectreference =
                        record.objectreference +
                        (!isNil(record.objectreference) ? '_' : '');

                      let newFilename =
                        _objectreference +
                        parts[0] +
                        '_' +
                        _.random(1000, 3000) +
                        '.' +
                        parts[1];

                      const newFile = new File([file], newFilename, {
                        type: file.type,
                      });

                      return newFile;
                    }}
                  // onChange={(e) => {
                  //   console.log('e', e);

                  // }}
                  >
                    <UploadButtonAction onlyIcon style={{ width: 80 }} />
                  </Upload>
                )}
            </Col>
          </Row>
        ),
        fixed: 'right',
        width: '100px',
        align: 'center',
      },
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      handlePreviewDOC,
      refetch,
      Params.handlePreviewDOC,
      handleUpdateDocStatus,
      Tpid,
    ]
  );
  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const columnsFilter = () => {
    let columnsFiltred = columns;
    /*if (objecttype && objectid) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return (
          column.dataIndex !== 'docmodule' &&
        //  column.dataIndex !== 'objectid' &&
          column.dataIndex !== 'tpname'
        );
      });
    } else if (objecttype) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return column.dataIndex !== 'docmodule';
      });
    }*/
    if (showAsModal)
      columnsFiltred = columnsFiltred.filter(
        (column: any) => column.key !== 'operation'
      );
    return columnsFiltred;
  };

  return (
    <DF.Provider pagcode="doclist">
      <Form form={form}>
        <Card
          style={{
            width: '100%',
          }}
          bordered
          className="p-13"
        >
          <Form.Item
            noStyle
            shouldUpdate={(prevValue: Values, nextValue: Values) => {
              return !isEqual(prevValue, nextValue);
            }}
          >
            <div>
              {showBtn ? (
                // <ButtonComponent
                //   type="primary"
                //   icon={<PlusOutlined />}
                //   style={{ height: 35 }}
                //   onClick={handleAddDocument}
                //   comcode="add"
                //   disabled={
                //     (status === 'PROPOSAL' && fromproposal === false) ||
                //     status === 'ORDER' ||
                //     status === 'DELIVER'
                //   }
                // />

                <ButtonOperation
                  comcode="Upload"
                  icon={<UploadOutlined />}
                  onClick={handleAddDocument}
                  disabled={
                    (status === 'PROPOSAL' && fromproposal === false) ||
                    status === 'ORDER' ||
                    status === 'DELIVER'
                  }
                />
              ) : _hideFilters ? (
                <DataGrid
                  rowKey="docid"
                  dataSource={data}
                  columns={columnsFilter()}
                  titleComcode={
                    title
                      ? ''
                      : categorie === 'CHECK'
                        ? 'Checklists'
                        : 'Documents'
                  }
                  onSearch={(values) => {
                    setsearchs(true);
                    setSearchParams({
                      ...searchParams,
                      docmodule: values.docmodule,
                      objectid: values.objectid ?? selectedObjectid,
                      doctype: values.doctype,
                      doccode: values.doccode,
                      applyFilter: searchParams.applyFilter,
                      docstatus: values.docstatus,
                      tpid: values?.tpid ?? Tpid,
                    });

                    refetch();
                  }}
                  onClear={() => {
                    setcheckdocmodule('');
                    setSelectedObjectid(0);
                    setdoctype('');
                    setSearchParams(intValueSearch);
                    form.resetFields();
                  }}
                  initialSearchValues={intValueSearch}
                  isLoading={isFetching}
                  hideFilters
                  pagination={pagination ?? { pageSize: 10 }}
                  extraActions={
                    showAsModal || hideBtn ? (
                      <div></div>
                    ) : hideFilters ? (
                      <>
                        <NewButton
                          type="primary"
                          icon={<PlusOutlined />}
                          style={{ height: 35 }}
                          onClick={handleAddDocument}
                          loading={loadingBtn}
                          comcode="add"
                          disabled={
                            (status === 'PROPOSAL' && fromproposal === false) ||
                            status === 'ORDER' ||
                            status === 'DELIVER'
                          }
                        />
                        &nbsp;&nbsp;
                        <Checkbox
                          defaultChecked={applyFilter ? true : false}
                          name="applyFilter"
                          style={{ fontSize: 20 }}
                          onChange={(e) => {
                            setSearchParams({
                              ...searchParams,
                              applyFilter: e.target.checked,
                            });
                            setsearchs(true);
                            refetch();
                          }}
                        />
                        <GetLabel
                          style={{ fontSize: '15px' }}
                          label="applyFilters"
                        />
                      </>
                    ) : (
                      <>
                        <ButtonComponent
                          type="primary"
                          icon={<PlusOutlined />}
                          onClick={handleAddDocument}
                          comcode="add"
                          style={
                            title
                              ? { height: 52, width: '100%' }
                              : { height: 35 }
                          }
                          disabled={
                            (status === 'PROPOSAL' && fromproposal === false) ||
                            status === 'ORDER' ||
                            status === 'DELIVER'
                          }
                        />
                        &nbsp;&nbsp;
                        <Checkbox
                          defaultChecked={applyFilter ? true : false}
                          name="applyFilter"
                          style={{ fontSize: 20 }}
                          onChange={(e) => {
                            setSearchParams({
                              ...searchParams,
                              applyFilter: e.target.checked,
                            });
                            setsearchs(true);
                            refetch();
                          }}
                        />
                        <GetLabel
                          style={{ fontSize: '15px' }}
                          label="applyFilters"
                        />
                      </>
                    )
                  }
                />
              ) : rowSelection ? (
                <DataGrid
                  rowKey="docid"
                  dataSource={data}
                  columns={columnsFilter()}
                  titleComcode={
                    title
                      ? ''
                      : categorie === 'CHECK'
                        ? 'Checklists'
                        : 'Documents'
                  }
                  onSearch={(values) => {
                    setsearchs(true);
                    setSearchParams({
                      ...searchParams,
                      docmodule: values.docmodule,
                      objectid: values.objectid ?? selectedObjectid,
                      doctype: values.doctype,
                      doccode: values.doccode,
                      applyFilter: searchParams.applyFilter,
                      docstatus: values.docstatus,
                      tpid: values.tpid ?? Tpid,
                    });

                    refetch();
                  }}
                  onClear={() => {
                    setcheckdocmodule('');
                    setSelectedObjectid(0);
                    setdoctype('');
                    setSearchParams(intValueSearch);
                    form.resetFields();
                  }}
                  rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                  }}
                  initialSearchValues={intValueSearch}
                  isLoading={isFetching}
                  pagination={pagination ?? { pageSize: 10 }}
                  extraActions={
                    <>
                      <ButtonComponent
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAddDocument}
                        comcode="addtt"
                        style={
                          title ? { height: 52, width: '100%' } : { height: 35 }
                        }
                        disabled={
                          (status === 'PROPOSAL' && fromproposal === false) ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      />
                      &nbsp;&nbsp;
                      <Checkbox
                        defaultChecked={applyFilter ? true : false}
                        name="applyFilter"
                        style={{ fontSize: 20 }}
                        onChange={(e) => {
                          setSearchParams({
                            ...searchParams,
                            applyFilter: e.target.checked,
                          });
                          setsearchs(true);
                          refetch();
                        }}
                      />
                      <GetLabel
                        style={{ fontSize: '15px' }}
                        label="applyFilters"
                      />
                    </>
                  }
                />
              ) : (
                <DataGrid
                  rowKey="docid"
                  dataSource={data}
                  columns={columnsFilter()}
                  titleComcode={
                    title
                      ? ''
                      : categorie === 'CHECK'
                        ? 'Checklists'
                        : 'Documents'
                  }
                  onSearch={(values) => {
                    setsearchs(true);
                    setSearchParams({
                      ...searchParams,
                      docmodule: values.docmodule,
                      objectid: values.objectid ?? selectedObjectid,
                      doctype: values.doctype,
                      doccode: values.doccode,
                      applyFilter: searchParams.applyFilter,
                      docstatus: values.docstatus,
                      tpid: values.tpid ?? Tpid,
                    });

                    refetch();
                  }}
                  onClear={() => {
                    setcheckdocmodule('');
                    setSelectedObjectid(0);
                    setdoctype('');
                    setSearchParams(intValueSearch);
                    form.resetFields();
                  }}
                  initialSearchValues={intValueSearch}
                  isLoading={isFetching}
                  pagination={pagination ?? { pageSize: 10 }}
                  extraActions={
                    showAsModal || hideBtn ? (
                      <div></div>
                    ) : hideFilters ? (
                      <>
                        <NewButton
                          type="primary"
                          icon={<PlusOutlined />}
                          style={{ height: 35 }}
                          onClick={handleAddDocument}
                          loading={loadingBtn}
                          comcode="add"
                          disabled={
                            (status === 'PROPOSAL' && fromproposal === false) ||
                            status === 'ORDER' ||
                            status === 'DELIVER'
                          }
                        />
                        &nbsp;&nbsp;
                        <Checkbox
                          defaultChecked={applyFilter ? true : false}
                          name="applyFilter"
                          style={{ fontSize: 20 }}
                          onChange={(e) => {
                            setSearchParams({
                              ...searchParams,
                              applyFilter: e.target.checked,
                            });
                            setsearchs(true);
                            refetch();
                          }}
                        />
                        <GetLabel
                          style={{ fontSize: '15px' }}
                          label="applyFilters"
                        />
                      </>
                    ) : (
                      <>
                        <ButtonComponent
                          type="primary"
                          icon={<PlusOutlined />}
                          onClick={handleAddDocument}
                          comcode="add"
                          style={
                            title
                              ? { height: 52, width: '100%' }
                              : { height: 35 }
                          }
                          disabled={
                            (status === 'PROPOSAL' && fromproposal === false) ||
                            status === 'ORDER' ||
                            status === 'DELIVER'
                          }
                        />
                        &nbsp;&nbsp;
                        <Checkbox
                          defaultChecked={applyFilter ? true : false}
                          name="applyFilter"
                          style={{ fontSize: 20 }}
                          onChange={(e) => {
                            setSearchParams({
                              ...searchParams,
                              applyFilter: e.target.checked,
                            });
                            setsearchs(true);
                            refetch();
                          }}
                        />
                        <GetLabel
                          style={{ fontSize: '15px' }}
                          label="applyFilters"
                        />
                      </>
                    )
                  }
                />
              )}
            </div>
          </Form.Item>
        </Card>
        <Modal
          visible={Params.showAddDocument}
          title={Params.previewTitle}
          footer={null}
          destroyOnClose
          onCancel={handleCancelAddDocument}
          width="1000px"
          style={{
            top: 100,
            right: 10,
            left: 10,
          }}
        >
          <Card>
            <Form
              layout="vertical"
              form={formModal}
              onFinishFailed={() => setfailed(true)}
              onFinish={() => setfailed(false)}
            >
              <Row gutter={[8, 8]}>
                <Col xs={16}>
                  <Row gutter={[8, 8]}>
                    <Form.Item
                      shouldUpdate={() => true}
                      noStyle
                      hidden={!!objecttype}
                    >
                      <FormInput
                        name="docmodule"
                        col
                        xs={12}
                        lg={12}
                        rules={[{ required: !objecttype }]}
                      >
                        {!objecttype ? (
                          <ParListSelect
                            parcode="DOCMODULE"
                            style={{ width: '150px' }}
                          ></ParListSelect>
                        ) : (
                          <Input disabled defaultValue={objecttype} />
                        )}
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('docmodule')}
                      noStyle
                      hidden={!!objecttype}
                    >
                      {({ getFieldValue }) => (
                        <FormInput
                          name="objectid"
                          col
                          xs={12}
                          lg={12}
                          rules={[{ required: !objecttype }]}
                        >
                          {!objecttype ? (
                            getFieldValue('docmodule') === 'THIRDPARTY' ? (
                              <ThirdPartyInput
                                onChange={(e) => {
                                  formModal.setFieldsValue({
                                    objectid: e.tpid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'PROPOSAL' ? (
                              <ProposalSelect
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.ctrid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'ASSET' ? (
                              <AssetSelect
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.assetid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'SINVOICE' ? (
                              <SupplierInvoiceSelect
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.siid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'CONTRACT' ? (
                              <ProposalSelect
                                phase="ACTIVE"
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.ctrid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'GUARANTIES' ? (
                              <GuarantySelect
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.guarid,
                                  });
                                }}
                              />
                            ) : getFieldValue('docmodule') === 'COLLECTION' ? (
                              <CollectionSelect
                                onChange={(e: any) => {
                                  formModal.setFieldsValue({
                                    objectid: e.colid,
                                  });
                                }}
                              />
                            ) : (
                              <Input
                                disabled
                                defaultValue="Please select an object"
                              />
                            )
                          ) : (
                            <Input disabled defaultValue={objectid} />
                          )}
                        </FormInput>
                      )}
                    </Form.Item>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('docmodule')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="doctype"
                            rules={[{ required: true }]}
                          >
                            <ParListSelect
                              parcode="DOCTYPE"
                              parvalueparent={
                                !objecttype
                                  ? getFieldValue('docmodule')
                                  : objecttype
                              }
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('doctype')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const DOCTYPE = getFieldValue('doctype');
                        const module = getFieldValue('docmodule');

                        return categorie === 'CHECK' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="doccode"
                            rules={[{ required: true }]}
                          >
                            <DocCodeSelect
                              doctype={DOCTYPE}
                              docmodule={!objecttype ? module : objecttype}
                              categorie="CHECK"
                              isboth
                            />
                          </FormInput>
                        ) : (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="doccode"
                            rules={[{ required: true }]}
                          >
                            <DocCodeSelect
                              doctype={DOCTYPE}
                              docmodule={!objecttype ? module : objecttype}
                              categorie={categorie}
                              isboth
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                  </Row>
                </Col>
                <Col xs={8}>
                  <Card>
                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <Upload
                            name="avatar"
                            multiple={false}
                            // action={UPLOAD_DOC_URL}
                            customRequest={(data: any) => {
                              UploadDocumentFile(
                                data.file,
                                objectreference ?? ''
                              );
                            }}
                            onPreview={Params.handlePreviewDOC}
                            beforeUpload={(file) => {
                              if (
                                file.type.substring(0, 5) !== 'image' &&
                                file.type !== 'application/pdf'
                              ) {
                                notification.error({
                                  message: `${file.name} is not an image or pdf file`,
                                  description: '',
                                  duration: 1,
                                });
                                setParams({ ...Params, goodtype: false });
                                return false;
                              }
                              setParams({ ...Params, goodtype: true });
                              return true;
                            }}
                            onChange={({ file, fileList }) => {
                              if (file.status === 'done') {
                                handleUpload(0, file, '');
                              }
                            }}
                          >
                            <UploadButtonAction
                              disabled={
                                !formModal.getFieldValue('docmodule') ||
                                formModal.getFieldValue('docmodule') === '' ||
                                !formModal.getFieldValue('doctype') ||
                                formModal.getFieldValue('doctype') === '' ||
                                !formModal.getFieldValue('objectid') ||
                                formModal.getFieldValue('objectid') === '' ||
                                !formModal.getFieldValue('doccode') ||
                                formModal.getFieldValue('doccode') === ''
                              }
                            />
                          </Upload>
                        );
                      }}
                    </Form.Item>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Card>
        </Modal>
      </Form>
      <Modal
        visible={Params.previewVisibleDOC}
        title={Params.previewTitle}
        footer={null}
        onCancel={handleCancelPreviewDOC}
        width="850px"
        style={{
          top: 20,
          right: 0,
        }}
      >
        {Params.isPDF && (
          <div>
            <Row>
              <Col>
                <InputNumber
                  min={10}
                  max={200}
                  formatter={(value) => `${value}%`}
                  step={10}
                  defaultValue={100}
                  onChange={onChangepdfZoom}
                />
              </Col>
            </Row>
            <h2>{info}</h2>

            <Document
              file={
                'data:image/jpeg;charset=utf-8;base64, ' + Params.previewImage
              }
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={() => setinfo('THERE IS NO PDF FOR THIS PRINTID')}
            >
              <Page pageNumber={pageNumber} scale={scale} />
            </Document>
            <div>
              <p>
                Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
              </p>
              <PrevButton
                disabled={pageNumber <= 1}
                onClick={previousPage}
                comcode="Previous"
              />

              <NextButton
                disabled={pageNumber >= numPages}
                onClick={nextPage}
                comcode="Next"
              />
            </div>
          </div>
        )}

        {!Params.isPDF && (
          <img
            alt="example"
            style={{ width: '100%' }}
            src={'data:image/jpeg;charset=utf-8;base64, ' + Params.previewImage}
          />
        )}
      </Modal>
    </DF.Provider>
  );
};

export default DocList;
